module.exports = __webpack_public_path__ + "img/hospital_white.8c5e2049.svg";